import { ReactNode, useState } from 'react';

import { APTypography } from '@astropay/web-core-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Collapse, List, ListItem, ListItemAvatar, useTheme } from '@material-ui/core';
import classNames from 'classnames';

import { useCollapsableStyles } from './styles';

interface ApCollapsableProps {
  mainText: string | ReactNode;
  secondaryText?: string;
  rightText?: string;
  children?: ReactNode;
  unStyled?: boolean;
  isOpen?: boolean;
}

const ApCollapsable: React.FC<ApCollapsableProps> = ({
  mainText,
  secondaryText,
  rightText,
  children,
  unStyled = false,
  isOpen = false,
}) => {
  const [open, setOpen] = useState(isOpen);
  const classes = useCollapsableStyles();
  const theme = useTheme();

  return (
    <Box className={classNames(`${classes.box} column`, { noStyle: unStyled })}>
      <List disablePadding style={{ width: '100%' }}>
        <ListItem className="infoItem first" onClick={children ? () => setOpen(!open) : undefined}>
          <Box>
            {mainText}
            <APTypography textStyle="Typography_Poppins_12px_Medium" text={secondaryText} />
          </Box>
          <ListItemAvatar
            className={classNames('collapsable-title', { textOnly: !children || unStyled })}
          >
            <Box>
              {rightText && (
                <APTypography textStyle="Typography_Poppins_14px_SemiBold" text={rightText} />
              )}
              {children && (
                <FontAwesomeIcon
                  icon={['fas', `chevron-${open ? 'up' : 'down'}`]}
                  size="xs"
                  color={theme.colors.Text_1}
                />
              )}
            </Box>
          </ListItemAvatar>
        </ListItem>
      </List>
      {children && (
        <Collapse in={open} timeout="auto" style={{ width: '100%' }}>
          <List dense={false} disablePadding={true} style={{ width: '100%' }}>
            {children}
          </List>
        </Collapse>
      )}
    </Box>
  );
};

export default ApCollapsable;
